export default __webpack_public_path__ + "static/media/solflare-icon.5cb6304d.png";